import { useEffect, useState } from "react";
import { BiLoaderCircle } from "react-icons/bi";
import { connect } from "react-redux";
import { DropDownListComponent } from "@syncfusion/ej2-react-dropdowns";
import toast from "react-hot-toast";
import moment from "moment";

import ChagePasswordForm from "./ChagePasswordForm";
import DeleteAccountButton from "./DeleteAccountButton";
import CustomDatePickerV2 from "../../../common/CustomDatePickerV2";
import CustomModal from "../../../common/CustomModal";
import CustomButton from "../../../common/CustomButton";
import CustomActionButton from "../../../common/CustomActionButton";

import { CheckPassword, ChangePassword, UpdateUserInfo } from "../../../redux/v2/user/actions";
import { Months } from "../../../constants";

function Profile(props) {
    const genderArray = ["Male", "Female", "Gender not listed", "Prefer not to say"];
    const genderValue = {
        Male: "M",
        Female: "F",
        "Gender not listed": "GNL",
        "Prefer not to say": "PNTS",
    };
    const genderValueRev = {
        M: "Male",
        F: "Female",
        O: "Gender not listed",
        GNL: "Gender not listed",
        PNTS: "Prefer not to say",
    };

    const [showModal, setShowModal] = useState(false);

    const [passwords, setPasswords] = useState({
        current: {
            value: "",
            visible: false,
            valid: true,
        },
        new: {
            value: "",
            visible: false,
            valid: true,
        },
        confirm: {
            value: "",
            visible: false,
            valid: true,
        },
    });

    const [submit, setSubmit] = useState(false);
    const [newPassword, setNewPassword] = useState("");

    const Delay = (cb, time = 1000) => {
        let timer = setTimeout(() => {
            cb();
            clearTimeout(timer);
        }, time);
    };

    const { account } = props.User;

    const [profile, setProfile] = useState({
        username: account?.user?.user_name,
        emailAddress: account?.user?.email_address,
        name: {
            first: account?.user?.first_name,
            last: account?.user?.last_name,
        },
        dob: account?.user?.dob,
        gender: genderValueRev[account?.user?.gender],
    });

    const { username, emailAddress, name, dob, gender } = profile;
    const formComplete = username && username != "" && emailAddress && emailAddress != "" && name.first && name.first != "" && name.last && name.last != "" && dob && dob != "" && gender && gender != "";

    useEffect(() => {
        setProfile({
            username: account?.user?.user_name,
            emailAddress: account?.user?.email_address,
            name: {
                first: account?.user?.first_name,
                last: account?.user?.last_name,
            },
            dob: account?.user?.dob,
            gender: genderValueRev[account?.user?.gender],
        });
    }, [account?.user, account?.user?.id]);

    const [currentButton, setCurrentButton] = useState(0);
    const buttons = [
        <CustomButton
            onClick={() => {
                setCurrentButton(2);
                Delay(() => {
                    setCurrentButton(1);
                }, 500);
            }}
        >
            UPDATE PROFILE
        </CustomButton>,

        <CustomButton
            onClick={async () => {
                setCurrentButton(2);
                const res = await props.UpdateUserInfo(profile);

                if (res.success) {
                    toast.success("Updated successfully");
                    setCurrentButton(3);
                    Delay(() => {
                        setCurrentButton(0);
                    }, 1000);
                } else {
                    toast.error("Failed to updated");
                    setCurrentButton(0);
                }
            }}
        >
            CONFIRM?
        </CustomButton>,

        <CustomButton>
            <BiLoaderCircle className="btn-loading" style={{ margin: "0" }} />
        </CustomButton>,

        <CustomButton>SAVED!</CustomButton>,
    ];

    return (
        <div id="profile-form" className="my-account-form">
            <CustomModal
                toggle={() => {
                    setShowModal(!showModal);
                }}
                id="change-pass-modal"
                show={showModal}
                title="CHANGE PASSWORD"
                body={
                    <ChagePasswordForm
                        toggleMainActionButton={(bool) => {
                            setSubmit(bool);
                        }}
                        setNewPassword={(value) => {
                            setNewPassword(value);
                        }}
                    />
                }
                footerButtons={[
                    {
                        label: "Cancel",
                        action: () => {
                            setShowModal(!showModal);
                        },
                        className: "cancel-button",
                    },
                    {
                        label: "Change",
                        action: async () => {
                            const res = await props.ChangePassword(newPassword);
                            if (res.success) {
                                toast.success("Password successfully updated");
                                setShowModal(!showModal);
                            } else {
                                toast.error("Failed to updated password");
                            }
                        },
                        className: "btn-gray",
                        disabled: submit ? false : true,
                    },
                ]}
            />

            <div className="row">
                <div className="col-md-12 profile-inputs">
                    {account?.user?.auth_provider == null && (
                        <div className="row">
                            <h5>EMAIL</h5>
                            <input
                                className="form-control"
                                value={profile.emailAddress}
                                type="text"
                                placeholder="Email Address"
                                onChange={(e) => {
                                    setCurrentButton(0);
                                    setProfile({
                                        ...profile,
                                        emailAddress: e.target.value,
                                    });
                                }}
                            />
                        </div>
                    )}

                    <div className="row">
                        <h5>NAME</h5>
                        <div className="name-inputs">
                            <input
                                className="form-control"
                                value={profile.name.first}
                                type="text"
                                placeholder="First"
                                onChange={(e) => {
                                    setCurrentButton(0);
                                    setProfile({
                                        ...profile,
                                        name: {
                                            ...profile.name,
                                            first: e.target.value,
                                        },
                                    });
                                }}
                            />
                            <input
                                className="form-control"
                                value={profile.name.last}
                                type="text"
                                placeholder="Last"
                                onChange={(e) => {
                                    setCurrentButton(0);
                                    setProfile({
                                        ...profile,
                                        name: {
                                            ...profile.name,
                                            last: e.target.value,
                                        },
                                    });
                                }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <h5>DATE OF BIRTH</h5>
                        <div id="my-date-picker">
                            <CustomDatePickerV2
                                value={moment(profile.dob).format("MM/DD/YYYY")}
                                onChange={(e) => {
                                    setCurrentButton(0);
                                    setProfile({
                                        ...profile,
                                        dob: e,
                                    });
                                }}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <h5>GENDER</h5>
                        <div id="drop-down-list">
                            <DropDownListComponent
                                style={{
                                    fontSize: "1rem",
                                }}
                                value={profile.gender}
                                dataSource={genderArray}
                                placeholder="GENDER"
                                className="field"
                                onChange={(e) => {
                                    setCurrentButton(0);
                                    setProfile({
                                        ...profile,
                                        gender: genderValue[e.target.value],
                                    });
                                }}
                            />
                        </div>
                    </div>

                    <div className="row">
                        <div className="lower-button-action">
                            <div>
                                <CustomActionButton
                                    action={async () => {
                                        const res = await props.UpdateUserInfo(profile);

                                        if (res.success) {
                                            toast.success("Updated successfully");
                                            return true;
                                        } else {
                                            toast.error("Failed to updated");
                                            return false;
                                        }
                                    }}
                                >
                                    UPDATE PROFILE
                                </CustomActionButton>
                                {/* {buttons[currentButton]} */}
                            </div>
                            <div>
                                {!account?.user?.auth_provider && (
                                    <CustomButton
                                        isPrimary={false}
                                        onClick={() => {
                                            setShowModal(!showModal);
                                        }}
                                    >
                                        CHANGE PASSWORD
                                    </CustomButton>
                                )}
                            </div>
                        </div>
                    </div>

                    <DeleteAccountButton />
                </div>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    User: state.User,
});

export default connect(mapStateToProps, {
    CheckPassword,
    ChangePassword,
    UpdateUserInfo,
})(Profile);
